import React from 'react';
import { PickupPointTableActionTypes } from '../../types';
import { CreatePickupPointModal } from './CreatePickupPointModal/CreatePickupPointModal';
import { DeletePickupPointModal } from './DeletePickupPointModal/DeletePickupPointModal';
import { PickupPointModalProps } from './PickupPointModal.type';

const getActionModal = (action: PickupPointTableActionTypes | null) => {
    switch (action) {
        case 'showCreateModal':
        case 'showEditModal':
            return CreatePickupPointModal;
        case 'showDeleteModal':
            return DeletePickupPointModal;
        default:
            return null;
    }
};

export const PickupPointModal: React.FunctionComponent<React.PropsWithChildren<PickupPointModalProps>> = ({
    action,
    onHide,
    brandId,
    restaurantId,
    pickupPointId,
    name,
    address,
    additionalAddressInfo,
    isOpen,
}) => {
    const ActionModal = getActionModal(action);

    if (!ActionModal) {
        return ActionModal;
    }

    return (
        <ActionModal
            onHide={onHide}
            brandId={brandId}
            restaurantId={restaurantId}
            pickupPointId={pickupPointId || 0}
            name={name || ''}
            address={address || ''}
            additionalAddressInfo={additionalAddressInfo || ''}
            isOpen={isOpen}
        />
    );
};
